<template lang="pug">
PartnerPage(title="Dashboard", :doc="doc")
  YearSelector(@select="load")
  v-row.my-3(wrap)
    v-col(cols="12", md="6")
      InteractionYearly(ref="interaction")
    v-col(cols="12", md="6")
      LeadYearly(ref="lead")
    v-col(cols="12", md="6")
      OpportunityYearly(ref="opportunity")
    v-col(cols="12", md="6")
      ContactYearly(ref="contact")
    v-col(cols="12", md="6")
      ServiceLogYearly(ref="serviceLog")
</template>

<script>
import ContactYearly from "/libs/components/CRM/Contact/Yearly";
import LeadYearly from "/libs/components/CRM/Lead/Yearly";
import OpportunityYearly from "/libs/components/CRM/Opportunity/Yearly";
import InteractionYearly from "/libs/components/CRM/Interaction/Yearly";
import ServiceLogYearly from "/libs/components/CRM/ServiceLog/Yearly";

import { mapGetters } from "vuex";

export default {
  components: {
    ContactYearly,
    LeadYearly,
    OpportunityYearly,
    InteractionYearly,
    ServiceLogYearly,
  },
  data() {
    return {
      doc: "https://docs.selflane.com/partner/crm/dashboard/",
    };
  },
  computed: {
    ...mapGetters(["salesOrganization"]),
    ...mapGetters("crm", ["leads", "opportunities"]),
  },
  methods: {
    async load(year) {
      const organization = this.salesOrganization?._id;
      if (!organization) return;

      await this.$refs.contact.load({ year, organization });
      await this.$refs.lead.load({ year, organization });
      await this.$refs.opportunity.load({ year, organization });
      await this.$refs.interaction.load({ year, organization });
      await this.$refs.serviceLog.load({ year, organization });
    },
  },
};
</script>